import {
    FETCH_ATELIERSEARCH_BEGIN,
    FETCH_ATELIERSEARCH_SUCCESS,
    FETCH_ATELIERSEARCH_ERROR,
    ATELIERSEARCH_TOGGLE_HIDERESULT,
    SET_ATELIER_SEARCH_CRITERES,
    SET_ATELIER_SEARCH_RESULTS,
    DELETE_ATELIER_BEGIN,
    DELETE_ATELIER_ERROR,
    DELETE_ATELIER_RESET,
    DELETE_ATELIER_SUCCESS
} from '../actions/atelierSearchActions'

const initialState = {
    atelierFiches: [],
    criteres: null,
    // ⚠ PAS mort (contrairement à son jumeau dépannage, purgé le 31.07.2026) :
    // la page legacy `AtelierSearch.js` (/atelier/rechercher-legacy, formulaire
    // + tableau sur un seul écran) le lit et le bascule via
    // `atelierSearchToggleHideresult`. Il part avec elle.
    hideResult: true,
    loading: false,
    error: false,
    errorDetails: {},
    deleteAtelier: {
        deleting: false,
        deleted: false,
        error: false
    }
}

export default function atelierSearchReducer(state = initialState, action) {
    let nextState
    switch (action.type) {
        case FETCH_ATELIERSEARCH_BEGIN:
            return {
                ...state,
                loading: true,
                error: false,
                errorDetails: {}
            }

        case FETCH_ATELIERSEARCH_SUCCESS:
            nextState = {
                ...state,
                atelierFiches: action.payload.atelierFiches,
                loading: false,
                error: false,
                errorDetails: {}
            }
            return nextState

        case FETCH_ATELIERSEARCH_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                errorDetails: action.payload.error
            }

        case ATELIERSEARCH_TOGGLE_HIDERESULT:
            return {
                ...state,
                hideResult: !state.hideResult
            }
        case SET_ATELIER_SEARCH_CRITERES:
            return {
                ...state,
                criteres: action.payload.criteres
            }
        case SET_ATELIER_SEARCH_RESULTS:
            return {
                ...state,
                atelierFiches: action.payload.atelierFiches
            }
        // DELETE ATELIER
        case DELETE_ATELIER_BEGIN:
            return {
                ...state,
                deleteAtelier: {
                    deleted: false,
                    deleting: true,
                    error: false,
                    ticket: action.payload.ticket
                }
            }
        case DELETE_ATELIER_ERROR:
            // Réponse d'une suppression abandonnée (RESET depuis — page
            // quittée en pleine suppression) : pas pour le modal ouvert.
            if (action.payload.ticket !== state.deleteAtelier.ticket) return state
            return {
                ...state,
                deleteAtelier: {
                    deleted: false,
                    deleting: false,
                    error: action.payload.error
                }
            }
        case DELETE_ATELIER_SUCCESS:
            if (action.payload.ticket !== state.deleteAtelier.ticket)
                // Abandonnée (cf. ERROR) mais bien supprimée : seule sa
                // ligne quitte la liste — ni ✓ dans le modal d'une autre
                // fiche, ni résultats d'une recherche périmée.
                return {
                    ...state,
                    atelierFiches: state.atelierFiches.filter(
                        (f) => f.id !== action.payload.id
                    )
                }
            return {
                ...state,
                // Sans recherche relancée (fiche supprimée depuis la fiche,
                // résultats sans critères V2) : la liste perd juste la ligne.
                atelierFiches: action.payload.relance
                    ? action.payload.atelierFiches
                    : state.atelierFiches.filter((f) => f.id !== action.payload.id),
                deleteAtelier: {
                    deleted: true,
                    deleting: false,
                    error: false
                }
            }
        case DELETE_ATELIER_RESET:
            return {
                ...state,
                deleteAtelier: {
                    deleted: false,
                    deleting: false,
                    error: false
                }
            }
        default:
            return state
    }
}